export const PARTNER_SUBJECTS = [
    'PartnerDashboard',
    'PartnerMaterials',
    'PartnerNews'
];

//# sourceMappingURL=subjects.js.map